import React from "react";
import "../FBOHome.css";

const CardComponent = ({ item, onClickCard }) => {
  return (
    <div className="fbo-home-card" onClick={onClickCard}>
      <img
        src={item.icon}
        alt={item.title}
        width={item.width}
        height={item.height}
        className="fbo-home-card-icon"
      />
      <p>{item.title}</p>
    </div>
  );
};

export default CardComponent;
